module.exports = __webpack_public_path__ + "static/img/IMG_0911.4ccfbd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0911.jpg
// module id = ZtdE
// module chunks = 11